import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TSubscription } from '@/features/subscription/apiSlice';

export const BillingCoupon: React.FC<{ subscription: TSubscription }> = ({
  subscription,
}) => {
  if (!subscription.coupon || subscription.subscriptionStatus) {
    return null;
  }

  return (
    <div className={`${css.section} ${css.promo}`}>
      <div className={`${flex.row} ${flex.alignItemsCenter}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="gift" />
        </div>
        <span>Discount: {subscription.coupon.name}</span>
        <img
          style={{ width: '16px', marginLeft: '5px' }}
          src="/img/rocket-border-full.png"
        />
      </div>
    </div>
  );
};
